// DS5.2
import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import React from 'react';
import c from 'classnames';
import Tabs from '../..';
import s from './UnderlinedTabs.scss';
export const UnderlinedTabs = /*#__PURE__*/ React.forwardRef((_param, ref)=>{
    var { size = 'small', uniformTabWidth, items } = _param, props = _object_without_properties(_param, [
        "size",
        "uniformTabWidth",
        "items"
    ]);
    return /*#__PURE__*/ React.createElement(Tabs, _object_spread_props(_object_spread({}, props), {
        ref: ref,
        items: items.map((item)=>{
            if (item.hasNotification) {
                const modifiedItem = _object_spread_props(_object_spread({}, item), {
                    labelExtras: /*#__PURE__*/ React.createElement("div", {
                        className: s['notification-dot']
                    })
                });
                return modifiedItem;
            }
            return item;
        }),
        viewClassNames: {
            root: c(s['root'], s[size], uniformTabWidth && s['uniform-tabs']),
            tab: s['tab'],
            label: s['label'],
            prefix: s['prefix'],
            dropdown: s['dropdown'],
            'active-tab': s['active-tab']
        }
    }));
});
UnderlinedTabs.displayName = 'UnderlinedTabs';
export default UnderlinedTabs;
